<template>
  <div class="agent-forgot-password">
    <h3 class="agent-forgot-password__title">{{$tAuth('Forgot your password?')}}</h3>

    <BaseAlert v-if="messageSuccess"
               :value="messageSuccess"
               class="_success"/>

    <template v-else>
      <Note :value="$tAuthAgentLogin('reset note')"
            class="agent-forgot-password__comment"
      />

      <div class="agent-forgot-password__input-wrapper">
        <BaseInput v-model="inputs.login.value"
                 :error="inputs.login.error"
                 :label="$tAuthAgentLogin('input_login')"
                 name="agent-login"
                 autocomplete="agent-login"
                 class="auth-agent-login__input"/>

        <button class="agent-forgot-password__input-btn base-btn base-btn--green" @click.prevent="onSendCode">
          <BasePreloader v-if="pendingSend"/>
          <BaseSvg name="ico-arrow-light"/>
        </button>
      </div>

       <BaseAlert :value="overallErrorsMix"
                     class="auth-forgot-password__alert  _error"/>
     
    </template>

  </div>
</template>

<script>
  import formMixins from '../mixins/formMixins'
  import Note from './Note'
  // import TabsBlock from './TabsBlock'

  export default {
    mixins: [formMixins],
    components: {
      Note,
    },
    props: {
      defaultEmailPhone: String,
    },
    data() {
      return {
        pendingSend: false,
        pendingReset: false,
        inputs: {
          login: {
            value: '',
            error: null,
            name: 'login'
          },
        },
        inputsSend: {
          emailOrPhone: {
            value: '',
            error: null
          }
        },
        inputsNew: {
          token: {
            value: '',
            error: null
          },
          password: {
            value: '',
            error: null
          },
          password2: {
            value: '',
            error: null
          }
        },
        code: {
          value: '',
          error: null
        },
        isShowTabs: true,
        message: null,
        messageSuccess: null,
        initialTab: null,
        passwordErrorMsg: ''
      }
    },
    computed: {
      validMail() {
        return this.validateEmail(this.authTabs[0].input.value)
      },
      validPhone() {
        return this.validatePhone(this.authTabs[1].input.value)
      },
      passwordLongEnough() {
        return this.inputsNew.password.value && this.inputsNew.password.value.length >= 6
      },
      passwordHasNumber() {
        return /\d/.test(this.inputsNew.password.value)
      },
      passwordHasLetter() {
        return /[A-Za-z]/.test(this.inputsNew.password.value)
      },
      validCode() {
        return /^[1-9]{1}[0-9]{6}$/.test(this.code.value)
      }
    },
    methods: {
      onSendCode() {
        this.message = null
        this.resetErrorsMix()

        this.pendingSend = true
        console.log(this.createSendDataMix(this.inputs))
        // debugger
        
        this.$store.dispatch('user/forgotPasswordAgent', {
          login: this.createSendDataMix(this.inputs).login
        })
          .then(data => {
            this.message = data.message || null
            if (data.data == 'SUCCESS') {
              this.$vModal.open('successfully-sent', {
                title: this.$tAuthAgentLogin('successfully-sent-title'),
                text: this.$tAuthAgentLogin('link sent'),
              })
              this.$emit('close')
            }
          })
          .catch((error => {
            this.errorHandlerMix(error)
          }))
          .finally(() => {
            this.pendingSend = false
          })

      },
      validateEmail(value) {
        return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/img.test(value)
      },
      validatePhone(value) {
        return /([+]{0,1})([0-9]{8,12})/img.test(value)
      },
      savePhone(val) {
        this.authTabs[1].input.value = val
      }
    },
    created() {
      if (this.defaultEmailPhone) {
        if (this.validateEmail(this.defaultEmailPhone)) {
          this.authTabs[0].input.value = this.defaultEmailPhone
        } else if (this.validatePhone(this.defaultEmailPhone)) {
          this.authTabs[1].input.value = this.defaultEmailPhone
          this.initialTab = this.authTabs[1]
        }
      }
    }
  }
</script>

<style lang="less">

</style>
